import { _ as R } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.trim-6e13db75.js";
import { useTheme as Xe } from "@ucl/shared-component-foundations";
import { useState as A, useRef as fe, useCallback as Ie, useEffect as W } from "react";
import { styled as j } from "styled-components";
import "./es.object.keys-9d66766f.js";
import { getAriaProps as Ge } from "./aria.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Je } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as Pe } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { _ as M, T as Qe } from "./index-f5b44da3.js";
import { a as $ } from "./index-5d0f31c6.js";
import "./carousel.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./index-8b07dec9.js";
import { jsx as m, jsxs as be } from "react/jsx-runtime";
import { InputState as V } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.link-fd2676c6.js";
import { uniqueId as ge } from "./uniqueId.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./string-trim-14e37ad3.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./inherit-if-required-f068457b.js";
import "./es.regexp.to-string-e800d529.js";
import "./set-species-5ede2ed0.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.parse-float-020a2ae0.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./useWindowSize.js";
import "./es.array.join-c1bca812.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./index-f2264f1e.js";
import "./iconButton.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "@ucl/shared-icons";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./getElementPosition-8d0dbc61.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./string-html-forced-a746405b.js";
import "./es.global-this-a7f40ce1.js";
import "./closeButton.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./useMediaQuery.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./tooltip.js";
var Ce, ke, $e, Ye = "timePickerInput", Ze = j.div(Ce || (Ce = R([`
  display: `, `;
  width: `, `;
  padding: `, `;
  flex-direction: `, `;
  align-items: `, `;
  gap: `, `;
  && div[aria-disabled='true'] {
    filter: `, `;
    opacity: `, `;
    pointer-events: `, `;
  }
  & input[disabled]::placeholder {
    color: `, `;
  }
`])), function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.display;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.width;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.padding;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.flexDirection;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.alignItems;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.gap;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.filter;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.opacity;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.pointerEvents;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.Wrapper.input.disabledPlaceholder.color;
}), et = j.span(ke || (ke = R([`
  display: `, `;
  height: `, `;
  width: `, `;
  justify-content: `, `;
  align-items: `, `;
  gap: `, `;
  color: `, `;
  background-color: `, `;
  border: `, `;
  cursor: `, `;
  border-radius: `, `;
  &:disabled {
    cursor: `, `;
  }
  svg {
    height: `, ` !important;
    width: `, ` !important;
  }
`])), function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.display;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.height;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.width;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.justifyContent;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.alignItems;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.gap;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.color;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.backgroundColor;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.border;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.cursor;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.borderRadius;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.disabled.cursor;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.svg.height;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.ClearButton.svg.width;
}), tt = j.span($e || ($e = R([`
  display: `, `;
  align-items: `, `;
  gap: `, `;
  `, `
`])), function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.IconWrapper.display;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.IconWrapper.alignItems;
}, function(t) {
  var e;
  return t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.IconWrapper.gap;
}, function(t) {
  if (t.$hasClearIcon) {
    var e;
    return "margin-left: -" + (t == null || (e = t.theme) == null ? void 0 : e.components.timePickerInput.IconWrapper.marginLeft);
  }
});
function Te(t, e) {
  var I = t.trim();
  if (e === "12" && /^(a|p|am|pm)$/i.test(I.toLowerCase()))
    return ["", I.toUpperCase()];
  var c = -1;
  if (e === "12") {
    for (var s = 0; s < t.length; s++)
      if (/^[amp]$/i.test(t[s])) {
        c = s;
        break;
      }
  }
  var T = c > 0 ? t.substring(0, c) : t, _ = c > 0 ? t.substring(c) : "";
  return [T, _];
}
var _e = function(e) {
  var I, c, s, T, _ = e.placeholder, xe = _ === void 0 ? "Select time..." : _, U = e.size, we = U === void 0 ? "medium" : U, K = e.value, l = K === void 0 ? {
    inputValue: "",
    selectedValue: ""
  } : K, q = e.format, d = q === void 0 ? "12" : q, E = e.isDisabled, p = E === void 0 ? !1 : E, N = e.stepInterval, L = N === void 0 ? 60 : N, z = e.minTime, F = z === void 0 ? "12:00 AM" : z, H = e.maxTime, X = H === void 0 ? "11:00 PM" : H, P = e.options, G = e.hasClearIcon, J = G === void 0 ? !1 : G, Q = e.required, w = Q === void 0 ? !1 : Q, x = e.onChange, Y = e.onBlur, y = e.labelProp, ye = e.infoProp, Oe = e.trailingText, De = e.helperTextProp, Z = e.inputState, O = Z === void 0 ? V.NONE : Z, ee = e.exceedOverflow, Be = ee === void 0 ? !1 : ee, te = e.menuDirection, Se = te === void 0 ? "down_auto" : te, Ae = e.children, We = e.fullWidth, ne = e.menuOpen, re = ne === void 0 ? !1 : ne, oe = e.handleMenuOpen, ie = e.menuWidth, Me = ie === void 0 ? "280px" : ie, Ve = e.noResultText, Re = Je({
    label: "TimePickerInput"
  }), le = A([]), v = le[0], ae = le[1], ue = A([]), D = ue[0], b = ue[1], pe = A(!1), g = pe[0], B = pe[1], S = fe(ge(Ye)), me = fe(null), je = {
    inputValue: "",
    selectedValue: ""
  }, Ue = Ge("combobox", {
    ariaExpanded: g,
    ariaDisabled: p,
    ariaRequired: (I = y == null ? void 0 : y.showRequiredIndicator) != null ? I : w,
    ariaInvalid: V.ERROR === O || V.CAUTION === O,
    ariaHaspopup: "listbox",
    ariaControls: "list-" + S.current
  }), h = Xe(), ce = Ie(function(o, n, r, i) {
    for (var a = [], f = /* @__PURE__ */ new Date("01/01/2000 " + n), C = /* @__PURE__ */ new Date("01/01/2000 " + r), u = new Date(f.getTime()); u.getTime() <= C.getTime(); ) {
      var k = {
        label: ve(u, i),
        value: ve(u, i)
      };
      a.push(k), u.setMinutes(u.getMinutes() + o);
    }
    ae(a), b(a);
  }, []), se = Ie(function(o) {
    if (!o)
      return v;
    var n = Te(o, d), r = n[0], i = n[1], a = r.trim(), f = i.trim().toLowerCase();
    return v.filter(function(C) {
      var u = Te(C.label, d), k = u[0], ze = u[1], Fe = k.trim(), He = ze.trim().toLowerCase(), he = Fe.startsWith(a);
      return d === "12" ? he && He.includes(f) : he;
    });
  }, [d, v]);
  W(function() {
    P != null && P.length ? (ae(P), b(P)) : ce(L, F, X, d);
  }, [L, F, X, d, P, ce]), W(function() {
    var o, n = se((o = l.inputValue) == null ? void 0 : o.toLowerCase());
    l.inputValue ? b(n || []) : b(v);
  }, [se, l.inputValue, v]), W(function() {
    B(re);
  }, [re]);
  var de = function(n) {
    var r;
    n.stopPropagation(), x(je), b(v), (r = me.current) == null || r.focus();
  }, Ke = function(n) {
    var r = n.key.toUpperCase(), i = /\d/.test(r) || r === ":" || n.code === "Space" || d === "12" && (r === "A" || r === "P" || r === "M");
    if (i || n.code !== "Backspace" && n.code !== "Delete" && n.code !== "ArrowLeft" && n.code !== "ArrowRight" && n.code !== "ArrowUp" && n.code !== "ArrowDown" && n.code !== "Tab" && !(n.metaKey && n.code === "KeyA") && // Command + A on Mac
    !(n.ctrlKey && n.code === "KeyA") && n.preventDefault(), n.code === "Enter" && g) {
      var a = D[0];
      a && x({
        inputValue: a.label,
        selectedValue: a.label
      });
    }
  }, ve = function(n, r) {
    var i = n.getHours(), a = n.getMinutes(), f = a < 10 ? "0" + a : a;
    if (r === "12") {
      var C = i >= 12 ? "PM" : "AM", u = i % 12 || 12;
      return u + ":" + f + " " + C;
    } else {
      var k = i < 10 ? "0" + i : i;
      return k + ":" + f;
    }
  }, qe = function(n) {
    n.currentTarget.contains(n.relatedTarget) || Y == null || Y(n);
  }, Ee = Pe(Ae, {
    clearButton: _e.ClearIcon
  }, Pe.PickType.LAST), Ne = /* @__PURE__ */ m(et, Object.assign({
    "aria-label": "clear",
    tabIndex: 0,
    role: "button"
  }, (c = Ee.clearButton) == null ? void 0 : c.props, {
    onClick: de,
    onKeyUp: function(n) {
      (n.code === "Enter" || n.code === "Space") && (n.preventDefault(), n.stopPropagation(), de(n));
    },
    disabled: p,
    children: /* @__PURE__ */ m($, {
      icon: "cancelCloseFilled"
    })
  })), Le = D == null ? void 0 : D.map(function(o) {
    var n = o.label, r = o.value, i = o.disabled;
    return /* @__PURE__ */ m(M.Item, {
      label: n,
      value: r || n,
      disabled: !!i,
      isSelected: l.selectedValue === r
    }, r + "_" + ge(r));
  });
  return /* @__PURE__ */ m(Ze, Object.assign({
    onBlur: qe
  }, Re, {
    children: /* @__PURE__ */ be(M, {
      className: "no-filter",
      menuOpen: !p && g,
      onChange: function(n, r) {
        x({
          inputValue: r.label,
          selectedValue: r.label
        });
      },
      fullWidth: We,
      closeOnSelect: !0,
      handleMenuOpen: function(n) {
        B(n), oe == null || oe(n);
      },
      menuWidth: Me,
      isDisabled: p,
      uniqueIdentifier: S.current,
      exceedOverflow: Be,
      noResultText: Ve,
      menuDirection: Se,
      disableAutoFocus: !0,
      children: [/* @__PURE__ */ m(M.Control, {
        children: /* @__PURE__ */ m(Qe, Object.assign({
          id: "control-" + S.current,
          placeholder: xe,
          value: l != null && l.inputValue ? l == null ? void 0 : l.inputValue : "",
          onChange: function(n) {
            n.target.value = n.target.value.toUpperCase().slice(0, 8), x({
              inputValue: n.target.value,
              selectedValue: "" + l.selectedValue
            }), B(!0);
          },
          onKeyDown: Ke,
          startAdornmentProp: {
            startAdornment: /* @__PURE__ */ m($, {
              icon: "clock",
              style: {
                color: "" + (p ? h.components.timePickerInput.InlineStyles.icons.disableColor.clockIcon : h.components.timePickerInput.InlineStyles.icons.defaultColor.clockIcon)
              }
            })
          },
          endAdornmentProp: {
            endAdornment: /* @__PURE__ */ be(tt, {
              $hasClearIcon: !!(!(l == null || (s = l.inputValue) == null) && s.trim() && J),
              $isDisabled: p,
              children: [(l == null || (T = l.inputValue) == null ? void 0 : T.trim()) && J && Ne, g ? /* @__PURE__ */ m($, {
                icon: "caretUp",
                style: {
                  color: "" + (p ? h.components.timePickerInput.InlineStyles.icons.disableColor.caretUp : h.components.timePickerInput.InlineStyles.icons.defaultColor.caretUp),
                  pointerEvents: "none"
                }
              }) : /* @__PURE__ */ m($, {
                icon: "caretDown",
                style: {
                  color: "" + (p ? h.components.timePickerInput.InlineStyles.icons.disableColor.caretDown : h.components.timePickerInput.InlineStyles.icons.defaultColor.caretDown),
                  pointerEvents: "none"
                }
              })]
            })
          },
          onKeyUp: function(n) {
            n.code === "Space" && n.stopPropagation();
          },
          textSize: we,
          disabled: p,
          required: w,
          labelProp: Object.assign({
            showRequiredIndicator: w
          }, y),
          infoProp: Object.assign({}, ye),
          trailingText: Oe,
          helperTextProp: g ? void 0 : De,
          inputState: O
        }, Ue, {
          role: "combobox",
          inputRef: me
        }))
      }), Le]
    })
  }));
};
_e.ClearIcon = $;
export {
  _e as TimePickerInput
};
